import { render, staticRenderFns } from "./CbsWidgetChart.vue?vue&type=template&id=2a935709&scoped=true"
import script from "./CbsWidgetChart.vue?vue&type=script&lang=js"
export * from "./CbsWidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a935709",
  null
  
)

export default component.exports